module.exports = __webpack_public_path__ + "dimer/static/img/DrLMS.d0b7c75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/DrLMS.jpg
// module id = KXE6
// module chunks = 0